/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IBulkPurchaseViewProps } from './bulk-purchase';

/**
 * Bulk purchase view.
 * @param props - Bulk purchase view props.
 * @returns React node with a module.
 */
export const BulkPurchaseViewComponent: React.FC<IBulkPurchaseViewProps> = props => {
    return <Module {...props.container}>{props.content}</Module>;
};

export default BulkPurchaseViewComponent;
